<template>
  <div id="app">
    <sock ref="sock" />
    <router-view />

  </div>
</template>

<script>

import sock from '@/views/components/sock'
export default {
  name: 'App',
  components: {
    sock
  },
  provide() {
    return {
      reload: this.reload
    }
  },

  data() {
    return {
      isRouterAlive: true,

    }
  },
  created() {
    
  },
  mounted() {
    // window.onbeforeunload = e => {      //刷新时弹出提示

    //   this.$message({
    //     message: "正在重启站点"
    //   })

    // }
  },
  methods: {
    reload() {
      this.isRouterAlive = false
      this.$nextTick(function () {
        this.isRouterAlive = true
      })
    },
 

  }
}
</script>

<style lang="scss">
/*滚动条样式*/
::-webkit-scrollbar {
  width: 4px;
  height: 4px;
}
::-webkit-scrollbar-thumb {
  border-radius: 10px;
  -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.1);
  background: rgba(0, 0, 0, 0.1);
}
::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.1);
  border-radius: 0;
  background: rgba(0, 0, 0, 0.1);
}
</style>
